import validator from 'validator';
export const validate_login = (email, password, t) => {
  if (validator.isEmpty(email) || validator.isEmpty(password)) {
    return t('login.fields_empty');
  } else {
    if (!validator.isEmail(email)) {
      return t('login.email_invalid');
    }
  }
  return ''
}
